import React from "react";
import clsx from "clsx";

import styles from "./layout.module.scss";

type SectionContainerProps = {
	className?: string;
	children: any;
};

export const SectionContainer = ({
	children,
	className,
}: SectionContainerProps) => {
	return (
		<section className={clsx(styles.sectionContainer, className)}>
			{children}
		</section>
	);
};
